import React, {Component} from 'react';

export default class DotMouseWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseX: 0,
      mouseY: 0,
    };
  }

  onMouseMove = e => {
    this.setState({
      mouseX: e.pageX,
      mouseY: e.pageY,
    });
  };

  render() {
    const size = 10;

    return (
      <div
        onMouseMove={this.onMouseMove}
        style={{cursor: 'none', position: 'relative'}}
      >
        {this.props.children}
        <div
          style={{
            position: 'absolute',
            top: this.state.mouseY - size / 2,
            left: this.state.mouseX - size / 2,
            opacity: 0.5,
            borderRadius: size,
            width: size,
            height: size,
            background:
              this.props.p5State.spectrumColor === 'black'
                ? 'white'
                : this.props.p5State.spectrumColor,
            // border: 'solid 1px black',
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DotMouseWrapper.js